import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { SelectOption } from "@/types/table";

interface SimpleSelectProps {
  value: string | undefined;
  onChange: (value: string | undefined) => void;
  options: SelectOption[];
}

export function SimpleSelect({ value, onChange, options }: Readonly<SimpleSelectProps>) {
  const { t } = useTranslation();

  return (
    <div className="relative w-64">
      <Select value={value ?? ""} onValueChange={next => onChange(next || undefined)}>
        <SelectTrigger className="w-64 border-none shadow-none focus-visible:ring-[1px]">
          <SelectValue placeholder={t("common.all")} />
        </SelectTrigger>
        <SelectContent>
          {options.map(option => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {/* Radix Select bo'sh qiymatni tanlash imkonini bermaydi — "hammasi"
          ga qaytish uchun alohida tugma kerak. */}
      {value !== undefined && (
        <Button
          type="button"
          size="icon"
          variant="ghost"
          className="bg-accent absolute top-1 right-8 size-7"
          aria-label={t("common.reset")}
          onClick={() => onChange(undefined)}
        >
          <X className="size-4" />
        </Button>
      )}
    </div>
  );
}
